import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, Fragment as _Fragment, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "ep-mode" }
const _hoisted_2 = {
  class: "ep-seg",
  role: "tablist",
  "aria-label": "Edit or preview"
}
const _hoisted_3 = ["aria-selected"]
const _hoisted_4 = ["aria-selected"]
const _hoisted_5 = {
  key: 0,
  class: "ep-prevnote"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        type: "button",
        role: "tab",
        "aria-selected": !_ctx.preview,
        class: _normalizeClass({ on: !_ctx.preview }),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('edit')))
      }, [...(_cache[2] || (_cache[2] = [
        _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
          _createElementVNode("path", { d: "M4 20h4L18.5 9.5a2.83 2.83 0 0 0-4-4L4 16v4M13.5 6.5l4 4" })
        ], -1),
        _createTextVNode("Edit ", -1)
      ]))], 10, _hoisted_3),
      _createElementVNode("button", {
        type: "button",
        role: "tab",
        "aria-selected": _ctx.preview,
        class: _normalizeClass({ on: _ctx.preview }),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('preview')))
      }, [...(_cache[3] || (_cache[3] = [
        _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
          _createElementVNode("path", { d: "M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z" }),
          _createElementVNode("circle", {
            cx: "12",
            cy: "12",
            r: "3"
          })
        ], -1),
        _createTextVNode("Preview ", -1)
      ]))], 10, _hoisted_4)
    ]),
    (_ctx.preview)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _cache[4] || (_cache[4] = _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
            _createElementVNode("path", { d: "M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z" }),
            _createElementVNode("circle", {
              cx: "12",
              cy: "12",
              r: "3"
            })
          ], -1)),
          _cache[5] || (_cache[5] = _createTextVNode(" This is what your team will see after you save.", -1)),
          (_ctx.changedCount)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(" Changed " + _toDisplayString(_ctx.changedLabel) + " are marked.", 1)
              ], 64))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}